import { RxapDataSource } from 'eurogard-data-source';
import { Injectable, inject } from '@angular/core';
import { PanelAccordionDataSource } from 'eurogard-data-source/accordion';
import {
  NotificationAccordionSubscribedRoutersControllerGetByIdRemoteMethod
} from 'open-api-service-shared-features/remote-methods/notification-accordion-subscribed-routers-controller-get-by-id.remote-method';
import {
  NotificationAccordionSubscribedRoutersControllerGetByIdResponse
} from 'open-api-service-shared-features/responses/notification-accordion-subscribed-routers-controller-get-by-id.response';

@Injectable()
@RxapDataSource('subscribed-routers-panel')
export class SubscribedRoutersPanelDataSource extends PanelAccordionDataSource<NotificationAccordionSubscribedRoutersControllerGetByIdResponse> {
  protected override readonly method = inject(NotificationAccordionSubscribedRoutersControllerGetByIdRemoteMethod);
}
